import React from 'react';

import FormDialog from '../../form/form-dialog';
import FormInput from '../../form/form-input';
import Grid from '../../Grid';
import http from '../../utils/http';
import StatusMessage from '../../StatusMessage';
import useForm from '../../hooks/useForm';
import { ConfigContext } from '../../Config/ConfigContext';
import {
    Box
} from '@mui/system';

import {
    Button,
} from '@mui/material';

import {
    isEmpty
} from 'lodash';
import { useNavigate } from 'react-router-dom';

const addEmailTemplateSubmit = async ({
    values,
    onFail,
    onInvalidForm,
    onChangeBulk,
    onResetFormErrors,
}) => {
    onChangeBulk({
        statusType: '',
        statusMessage: '',
    });

    let errors = {};

    if (!values.templateName) errors.applicationName = 'Template Name is required';
    if (!values.subject) errors.subject = 'Subject is required';
    if (!values.from) errors.from = 'From Address is required';
    if (!isEmpty(errors)) return onInvalidForm(errors);

    onResetFormErrors();

    const result = await http.post({
        name: values.templateName,
        subject: values.subject,
        from: values.from,
    }, `${values.config.uri.base}/email/template`);

    if (result.errored)
        return onFail(result);

    onChangeBulk({
        templateName: '',
        subject: '',
        from: '',
        modalToggle: false,
        statusType: 'success',
        statusMessage: `Successfully saved new Email Template: ${values.name}`,
        _id: result._id
    });

};

export default function EmailTemplates() {
    const navigate = useNavigate();
    const { config } = React.useContext(ConfigContext)

    const {
        state,
        onChange,
        onInvalidForm,
        onFail,
        onChangeBulk,
        onResetFormErrors,
        onRefresh
    } = useForm({
        initialState: {
            modalToggle: false,
            config,
            applicationName: '',
            appId: '',
            statusType: '',
            statusMessage: '',
        },
    });

    const handleCloseModal = () => {
        onChange(!state.values.modalToggle, 'modalToggle');
    }

    return (
        <div>
            {state.values.statusType &&
                <StatusMessage
                    messageType={state.values.statusType}
                    message={state.values.statusMessage}
                />
            }

            {
                state.values.modalToggle &&
                <FormDialog
                    dialogTitle={'Add Email Template'}
                    dialogSubHeading={'Fill out this form to add a new email template to by used by the platform'}
                    isOpen={state.values.modalToggle}
                    handleClose={handleCloseModal}
                    handleSubmit={() => addEmailTemplateSubmit({
                        values: state.values,
                        onInvalidForm,
                        onFail,
                        onChangeBulk,
                        onResetFormErrors,
                        onRefresh
                    })}
                >
                    <Box
                        sx={{ display: 'flex', flexDirection: 'column' }}
                    >
                        <FormInput
                            label='Template Name'
                            path='templateName'
                            value={state.values.templateName}
                            error={state.errors.templateName}
                            onChange={onChange}
                        />
                        <FormInput
                            label='Subject'
                            path='subject'
                            value={state.values.subject}
                            error={state.errors.subject}
                            onChange={onChange}
                        />
                        <FormInput
                            label='From Address'
                            path='from'
                            value={state.values.from}
                            error={state.errors.from}
                            onChange={onChange}
                        />

                    </Box>
                </FormDialog>
            }

            <Box
                sx={{ display: 'flex', justifyContent: 'flex-end' }}
            >
                <Button
                    variant={'contained'}
                    onClick={() => onChange(!state.values.modalToggle, 'modalToggle')} >Add Email Template</Button>
            </Box>
            <Grid
                tableName={'Email Templates'}
                searchEndpont={`${config.uri.base}/email/template`}
                actionRowClick={({ rowData }) => navigate(`/admin/email/template/${rowData._id}`)}
                headCells={[
                    {
                        id: 'name',
                        numeric: false,
                        disablePadding: true,
                        label: 'Template Name',
                    },
                    {
                        id: 'subject',
                        numeric: false,
                        disablePadding: true,
                        label: 'Subject'
                    },
                    {
                        id: 'from',
                        numeric: false,
                        disablePadding: true,
                        label: 'From Address',
                    },
                    {
                        id: 'updatedAt',
                        numeric: false,
                        disablePadding: true,
                        label: 'Updated At',
                    },
                    {
                        id: 'insertedAt',
                        numeric: false,
                        disablePadding: true,
                        label: 'Created At',
                    },
                ]}
                filterList={[
                    {
                        id: 'name',
                        dataType: 'string',
                        label: 'Application Name',
                        defaultValue: ''
                    },

                ]}
            />

        </div>
    );
}

